export default "__VITE_ASSET__C6tnRGH0__"